import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ACTIVIDADES_ACADEMICAS = 'ALL_ACTIVIDADES_ACADEMICAS';
export const LOADING_ALL_ACTIVIDADES_ACADEMICAS =
  'LOADING_ALL_ACTIVIDADES_ACADEMICAS';
export const ACTIVO_ACTIVIDADES_ACADEMICAS = 'ACTIVO_ACTIVIDADES_ACADEMICAS';
export const PARAMS_ACTIVIDADES_ACADEMICAS = 'PARAMS_ACTIVIDADES_ACADEMICAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const actividadesAcademicasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ACTIVIDADES_ACADEMICAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_ACTIVIDADES_ACADEMICAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_ACTIVIDADES_ACADEMICAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_ACTIVIDADES_ACADEMICAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
